// extracted by mini-css-extract-plugin
export var firstHalf = "Home-module--firstHalf--NzzpL";
export var mainWrapper = "Home-module--mainWrapper--QEWLY";
export var touchPoints = "Home-module--touchPoints--CJjb8";